import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=3ac0d55a&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac0d55a",
  null
  
)

export default component.exports